import script from "./RegisterMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterMobile.vue?vue&type=script&setup=true&lang=js"

import "./RegisterMobile.vue?vue&type=style&index=0&id=57a78103&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a78103"]])

export default __exports__